import { render, staticRenderFns } from "./PricePartsDetails.vue?vue&type=template&id=0eb64c62"
import script from "./PricePartsDetails.vue?vue&type=script&lang=js"
export * from "./PricePartsDetails.vue?vue&type=script&lang=js"
import style0 from "./PricePartsDetails.vue?vue&type=style&index=0&id=0eb64c62&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb64c62')) {
      api.createRecord('0eb64c62', component.options)
    } else {
      api.reload('0eb64c62', component.options)
    }
    module.hot.accept("./PricePartsDetails.vue?vue&type=template&id=0eb64c62", function () {
      api.rerender('0eb64c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PriceParts/PricePartsDetails.vue"
export default component.exports